import { render, staticRenderFns } from "./WikiEditPage.vue?vue&type=template&id=ea04012c&scoped=true"
import script from "./WikiEditPage.vue?vue&type=script&lang=ts"
export * from "./WikiEditPage.vue?vue&type=script&lang=ts"
import style0 from "./WikiEditPage.vue?vue&type=style&index=0&id=ea04012c&prod&scoped=true&lang=css"
import style1 from "./WikiEditPage.vue?vue&type=style&index=1&id=ea04012c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea04012c",
  null
  
)

export default component.exports